import React from 'react';
import resume, { SkillGroup } from '../../data/resume';
import styles from './Skills.module.css';

interface SkillGroupCardProps {
  group: SkillGroup;
}

const SkillGroupCard: React.FC<SkillGroupCardProps> = ({ group }) => (
  <div className={styles.group}>
    <h3 className={styles.category}>{group.category}</h3>
    <div className={styles.chips}>
      {group.items.map((item, i) => (
        <span key={i} className={styles.chip}>
          {item}
        </span>
      ))}
    </div>
  </div>
);

const Skills: React.FC = () => (
  <section id="skills" className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.sectionTitle}>Skills</h2>
      <div className={styles.grid}>
        {resume.skills.map((group, i) => (
          <SkillGroupCard key={i} group={group} />
        ))}
      </div>

      <div className={styles.additionalWrapper}>
        <h2 className={styles.sectionTitle} style={{ marginTop: '60px' }}>
          Additional
        </h2>
        <ul className={styles.additionalList}>
          {resume.additionalInfo.map((item, i) => (
            <li key={i} className={styles.additionalItem}>
              <span className={styles.bulletDot} />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Skills;
